import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { FeatureFlagsConfigService, Store } from '@olympus/ngx-shared';
import { FileItem } from 'shared-business-angular/desktop-file-browser';
import { getExtensionsForFileType } from 'shared-utils/file-system';

import { DPUActionType } from '../../core/reducers/dpu/dpu.reducer';
import { ConfigService } from '../../core/services/config';

export const browseFileAcceptedExtensionsFactory = () => {
  const featureFlagsConfigService = inject(FeatureFlagsConfigService);

  return (): string[] => featureFlagsConfigService.getFeature('inspection')
    ? getExtensionsForFileType('setup').concat(getExtensionsForFileType('data'))
    : getExtensionsForFileType('data');
};

export const browseFileOpenLocalFileActionFactory = () => {
  const store = inject(Store);

  return (file: FileItem): void => {
    store.dispatch({
      type: DPUActionType.FILE_SELECTED,
      payload: file.id,
    });
  };
};

export const browseFileOpenDriveFileActionFactory = () => {
  const router = inject(Router);

  return (file: FileItem): void => {
    router.navigate(['/layout', 'default', 'download', 'fileid', file.id]);
  };
};

export const browseFileEnvConfigFactory = (): { isLocal: boolean, isCloudConnected: boolean } => {
  const configService = inject(ConfigService);

  return {
    isLocal: configService.isLocal,
    isCloudConnected: configService.isCloudConnected,
  };
};
